// extracted by mini-css-extract-plugin
export default {"checkbox":"Checkbox_checkbox__4BQge","selected":"Checkbox_selected__Ol9Dh"};